import React, { useRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import './UseCase.css'
import './UseCase-responsive.css';
import { Slide } from 'react-awesome-reveal';
import { Ripple } from "primereact/ripple";
import { Dialog } from "primereact/dialog";
import { Skeleton } from "primereact/skeleton";

import JoinUs from "../CommonSections/JoinUs";
import { UseCases, useCases, UseCaseFeatures } from "./UseCaseData";
import { goToTop } from "../../../WebApp/Components/goToTop";

const UseCase: React.FC = () => {
    const [useCaseData, setUseCaseData] = useState<UseCases[]>([]);
    const [selectedUseCaseData, setSelectedUseCaseData] = useState<UseCases | null>(null);
    const [showFeatureViewModal, setShowFeatureViewModal] = useState<boolean>(false);
    const [selectedFeatureData, setSelectedFeatureData] = useState<UseCaseFeatures | null>(null);
    const [contentLoading, setContentLoading] = useState<boolean>(false);
    const viewDetail = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const activeUseCases = useCases?.filter(useCase => useCase?.status === 1)
        setUseCaseData(activeUseCases);
        setSelectedUseCaseData(activeUseCases[0]);
    }, []);

    const handleViewUseCaseDetail = (data: UseCases) => {
        setContentLoading(true);
        setSelectedUseCaseData(data);
        setTimeout(() => {
            setContentLoading(false);
        }, 500);

        if (viewDetail.current) {
            const elementPosition = viewDetail.current.getBoundingClientRect().top + window.scrollY;
            const offsetPosition = elementPosition - 100;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth',
            });
        }
    }

    const handleViewUseCaseRoleFeature = (data: UseCaseFeatures) => {
        setShowFeatureViewModal(true);
        setSelectedFeatureData(data);
    }

    return (
        <React.Fragment>
            {/* Use case initial section */}
            <section className="page_initial_section use_case_init_section pattern_bg overflow-hidden">
                <div className="container-md">
                    <div className="row">
                        <div className="col-12 col-sm-5 col-lg-4 col-xl-4 use_case_roles">
                            {useCaseData && useCaseData?.length > 0 && (
                                <Slide direction="up" triggerOnce>
                                    <div className="use_case_roles_container">
                                        {useCaseData?.map((useCase) => (
                                            <article key={useCase?.id} onClick={() => handleViewUseCaseDetail(useCase)}
                                                className={`use_case_role ${useCase?.id === selectedUseCaseData?.id && 'active'} p-ripple`}>
                                                <h6>{useCase?.role}</h6>
                                                <i className="bi bi-chevron-right"></i>
                                                <Ripple />
                                            </article>
                                        ))}
                                    </div>
                                </Slide>
                            )}
                        </div>

                        <div className="col-12 col-sm-7 col-lg-8 col-xl-8" ref={viewDetail}>
                            {selectedUseCaseData && (
                                <Slide direction="up" delay={100} triggerOnce>
                                    <div className="use_case_detail_section" >
                                        <h3 className="use_case_heading">
                                            Connect&nbsp;{selectedUseCaseData?.role}&nbsp;Features
                                        </h3>
                                        <p className="use_case_desc">
                                            {selectedUseCaseData?.description}
                                        </p>

                                        {selectedUseCaseData?.features && selectedUseCaseData?.features?.length > 0 && (
                                            <React.Fragment>
                                                <div className="row use_case_feature_area">
                                                    {selectedUseCaseData?.features?.map((feature) => (
                                                        <div key={feature?.id} className="col-12 col-lg-6 col-xl-4 h-100">
                                                            {contentLoading ? (
                                                                <article className="use_case_feature_loading">
                                                                    <Skeleton width="35px" height="35px" className="img_loading" />
                                                                    <Skeleton width="90%" height="18px" className="heading_loding" />
                                                                    <Skeleton height="16px" className="paragraph_loading" />
                                                                    <Skeleton width="70%" height="16px" className="paragraph_loading mb-1" />
                                                                </article>
                                                            ) : (
                                                                <article className="use_case_feature_container p-ripple"
                                                                    onClick={() => handleViewUseCaseRoleFeature(feature)}>
                                                                    <img src={feature?.icon} alt={feature?.feature} loading="lazy" />
                                                                    <h4>{feature?.feature}</h4>
                                                                    <p>
                                                                        {feature.description.length > 50 ? `${feature.description.substring(0, 50)}...` : feature.description}
                                                                    </p>
                                                                    <Ripple />
                                                                </article>
                                                            )}
                                                        </div>
                                                    ))}
                                                </div>

                                                {/* <div className="get_start_btn_area justify-content-start pt-4">
                                                    <Link to={'/more-info'} className="tdo_button btn_fill p-ripple"
                                                        onClick={goToTop}>
                                                        More info
                                                        <Ripple />
                                                    </Link>
                                                </div> */}

                                                <div className="get_start_btn_area justify-content-start pt-4">
                                                    <Link to={'/pricing'} className="tdo_button btn_fill p-ripple"
                                                        onClick={goToTop}>
                                                        Get Started Now
                                                        <Ripple />
                                                    </Link>
                                                </div>
                                            </React.Fragment>
                                        )}
                                    </div>
                                </Slide>
                            )}
                        </div>
                    </div>
                </div>
            </section>

            {/* Join us section */}
            <section className="section__padding bg-white pt-0">
                <JoinUs />
            </section>

            {/* Feature detail modal */}
            <Dialog headerClassName="d-none" dismissableMask
                visible={showFeatureViewModal} className="custom_modal_dialog modal_dialog_md"
                onHide={() => { if (!showFeatureViewModal) return; setShowFeatureViewModal(false); }}>
                <div className="custom_modal_body">
                    <button className="custom_modal_close position-absolute float p-ripple"
                        onClick={() => setShowFeatureViewModal(false)}>
                        <i className="bi bi-x-lg"></i>
                        <Ripple />
                    </button>

                    {selectedFeatureData && (
                        <div className="use_case_feature_info">
                            <h6 className="review_head">{selectedFeatureData?.feature}</h6>
                            <p className="review_paragraph">
                                {selectedFeatureData?.description}
                            </p>
                        </div>
                    )}
                </div>
            </Dialog>
        </React.Fragment>
    )
}

export default UseCase;